import React, { FC } from "react";

import { ButtonProps } from "./Button.types";

import styles from "./Button.module.scss";
import { IconContext } from "react-icons";

const Button: FC<ButtonProps> = ({
  color = "primary",
  variant = "contained",
  size = "medium",
  children,
  startIcon,
  endIcon,
  fullWidth,
  ...rest
}) => {
  const onlyStartIcon = !children && !!startIcon && !endIcon;
  const onlyEndIcon = !children && !!endIcon && !startIcon;
  const className = `${styles.button} ${styles[color]} ${styles[variant]} ${
    styles[size]
  } ${onlyStartIcon || onlyEndIcon ? styles.iconOnly : ""} ${
    fullWidth ? styles.fullWidth : ""
  }`;
  return (
    <button
      {...rest}
      type="button"
      className={[className, rest.className].join(" ")}
      data-testid="button"
    >
      <IconContext.Provider value={{ size: "20px" }}>
        {!!startIcon && <span>{startIcon}</span>}
        {!!children && <span>{children}</span>}
        {!!endIcon && <span>{endIcon}</span>}
      </IconContext.Provider>
    </button>
  );
};

export default Button;
